import { styled } from "@mui/material/styles";
import { Box, Typography, TextField, Button } from "@mui/material";

export const FormContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius * 2,
  backgroundColor: "transparent",
  width: "100%",
  maxWidth: "720px",
  margin: "0 auto",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2.5),
    maxWidth: "100%",
  },
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  color: "#1e3a8a",
  fontSize: "1.6rem",
  fontWeight: 700,
  textAlign: "center",
  letterSpacing: "0.5px",
  [theme.breakpoints.up("md")]: {
    fontSize: "1.9rem",
  },
}));

export const StyledTextField = styled(TextField)(() => ({
  backgroundColor: "#f9fafb",
  borderRadius: 6,
  "& .MuiInputBase-input": {
    fontSize: "0.95rem",
    padding: "12px 14px",
    color: "#111",
  },
  "& .MuiInputLabel-root": {
    color: "#555",
    fontWeight: 500,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#ddd",
    },
    "&:hover fieldset": {
      borderColor: "#1e40af",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#2563eb",
      borderWidth: 2,
    },
  },
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  fontWeight: 600,
  textTransform: "none",
  borderRadius: 8,
  padding: theme.spacing(1.2, 4),
  fontSize: "0.95rem",
  transition: "all 0.2s ease-in-out",
  "&.MuiButton-contained": {
    backgroundColor: "#1e40af",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#2563eb",
    },
  },
  "&.MuiButton-outlined": {
    borderColor: "#cbd5e1",
    color: "#374151",
    backgroundColor: "#f9fafb",
    "&:hover": {
      backgroundColor: "#f3f4f6",
      borderColor: "#94a3b8",
    },
  },
}));


